import React, {useState, useEffect} from 'react';
import moment from 'moment-timezone';
import MyAdvancedTable from 'components/common/myAdvancedTable/myAdvancedTable';
import SubtleBadge from 'components/common/SubtleBadge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Axios } from 'helpers/axios';
import IconButton from 'components/common/IconButton';

const OneDPSDocuments = ({
    idDPS,
    documents,
    documentsGroupe,
    demandesDPS,
}) => {
    const [listeDocConcat, setListeDocConcat] = useState([]);

    const concatAll = () => {
        try {
            let tempArray = [];
            for(const doc of documents)
            {
                tempArray.push({
                    ...doc,
                    nomDocument: doc.nomDocumentDPS,
                    formatDocument: doc.formatDocumentDPS,
                    dateDocument: doc.dateDocumentDPS,
                    source: 'dps'
                })
            }
            for(const doc of documentsGroupe)
            {
                tempArray.push({
                    ...doc,
                    nomDocument: doc.nomDocumentGroupe,
                    formatDocument: doc.formatDocumentGroupe,
                    dateDocument: doc.dateDocumentGroupe,
                    source: 'groupe'
                })
            }
            for(const demande of demandesDPS)
            {
                for(const doc of demande.documents)
                {
                    tempArray.push({
                        ...doc,
                        nomDocument: doc.nomDocumentDemande,
                        formatDocument: doc.formatDocumentDemande,
                        dateDocument: doc.dateDocumentDemande,
                        source: 'demande'
                    })
                }
            }

            setListeDocConcat(tempArray);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        concatAll();
    },[
        documents,
        documentsGroupe,
    ]);

    const colonnes = [
        {
            accessorKey: 'nomDocument',
            header: 'Nom du document',
            cell: ({ row }) => {
				return(<>
                    {row.original.nomDocument}<br/>
                    <i>{row.original.libelleTypeDocument}</i>
                </>);
			},
        },
        {
            accessorKey: 'dateDocument',     
            header: 'Date',
            cell: ({ row }) => {
				return(moment(row.original.dateDocument).format('DD/MM/YYYY HH:mm'));
			},
        },
        {
            accessorKey: 'docusealIdSubmission',     
            header: 'Signature électronique',
            cell: ({ row }) => {
				return(<>
                    {!row.original.docusealIdTemplate && !row.original.docusealIdSubmission ?
                        <SubtleBadge bg='secondary'>N/A</SubtleBadge>
                    :
                        !row.original.docusealIdSubmission ?
                            <SubtleBadge bg='info'>A venir</SubtleBadge>
                        :
                            row.original.docusealDeclined ?
                                <SubtleBadge bg='danger'>Refusé/Avorté</SubtleBadge>
                            :
                                row.original.docusealSignDatetime ?
                                    <SubtleBadge bg='success'>Signé</SubtleBadge>
                                :
                                    <>
                                        <SubtleBadge bg='warning'>EN COURS</SubtleBadge><br/>
                                        {row.original.docusealSuivi.map((submitter, i)=>{return(
                                            <><FontAwesomeIcon
                                                key={i}
                                                icon={submitter.status == 'completed' ? 'check' : (submitter.status == 'sent' || submitter.status == 'opened') ? 'arrow-right' : submitter.status == 'declined' ? 'ban' : 'spinner'}
                                                className={'text-' + (submitter.status == 'completed' ? 'success' : (submitter.status == 'sent' || submitter.status == 'opened') ? 'primary' : submitter.status == 'declined' ? 'danger' : 'secondary')}
                                            /> {submitter.name}<br/></>
                                        )})}
                                    </>
                    }
                </>);
			},
        },
        {
            accessorKey: 'actions',       
            header: 'Actions',
            cell: ({ row }) => {
                return(<>
                    {row.original.urlFichierDocumentDPS && !row.original.docusealUrlFichierDocumentDPSsigne ? <>
                        {row.original.formatDocumentDPS == 'pdf' ? <IconButton size='sm' className='me-1 mt-1 mb-1' icon='eye' variant='info' onClick={() => {displayOnePDFDPS(row.original.urlFichierDocumentDPS)}}/> : null}
                        {["png", "jpg", "jpeg"].includes(row.original.formatDocumentDPS) ? <IconButton size='sm' className='me-1 mt-1 mb-1' icon='download' variant='success' onClick={() => {displayOnePictureDPS(row.original.urlFichierDocumentDPS, row.original.nomDocumentDPS, row.original.formatDocumentDPS)}}/> : null}
                        <IconButton size='sm' className='me-1 mt-1 mb-1' icon='download' variant='success' onClick={() => {downloadDocumentDPS(row.original.urlFichierDocumentDPS, row.original.nomDocumentDPS, row.original.formatDocumentDPS)}}/>
                    </>: null}

                    {row.original.urlFichierDocumentGroupe ? <>
                        {row.original.formatDocumentGroupe == 'pdf' ? <IconButton size='sm' className='me-1 mt-1 mb-1' icon='eye' variant='info' onClick={() => {displayOnePDFGROUPES(row.original.urlFichierDocumentGroupe)}}/> : null}
                        {["png", "jpg", "jpeg"].includes(row.original.formatDocumentGroupe) ? <IconButton size='sm' className='me-1 mt-1 mb-1' icon='download' variant='success' onClick={() => {displayOnePictureGROUPES(row.original.urlFichierDocumentGroupe, row.original.nomDocumentGroupe, row.original.formatDocumentGroupe)}}/> : null}
                        <IconButton size='sm' className='me-1 mt-1 mb-1' icon='download' variant='success' onClick={() => {downloadDocumentGROUPES(row.original.urlFichierDocumentGroupe, row.original.nomDocumentGroupe, row.original.formatDocumentGroupe)}}/>
                    </>:null}

                    {row.original.urlFichierDocumentDemande ? <>
                        {row.original.formatDocumentDemande == 'pdf' ? <IconButton size='sm' className='me-1 mt-1 mb-1' icon='eye' variant='info' onClick={() => {displayOnePDFDEMANDES(row.original.urlFichierDocumentDemande)}}/> : null}
                        {["png", "jpg", "jpeg"].includes(row.original.formatDocumentDemande) ? <IconButton size='sm' className='me-1 mt-1 mb-1' icon='download' variant='success' onClick={() => {displayOnePictureDEMANDES(row.original.urlFichierDocumentDemande, row.original.nomDocumentDemande, row.original.formatDocumentDemande)}}/> : null}
                        <IconButton size='sm' className='me-1 mt-1 mb-1' icon='download' variant='success' onClick={() => {downloadDocumentDEMANDES(row.original.urlFichierDocumentDemande, row.original.nomDocumentDemande, row.original.formatDocumentDemande)}}/>
                    </>:null}

                    {row.original.docusealUrlFichierDocumentDPSsigne ? <>
                        <IconButton size='sm' className='me-1 mt-1 mb-1' icon='eye' variant='info' onClick={() => {displayOnePDFDPS(row.original.docusealUrlFichierDocumentDPSsigne)}}/>
                        <IconButton size='sm' className='me-1 mt-1 mb-1' icon='download' variant='success' onClick={() => {downloadDocumentDPS(row.original.docusealUrlFichierDocumentDPSsigne, row.original.nomDocumentDPS, row.original.formatDocumentDPS)}}/>
                    </>: null}
                </>);
			},
        },
    ];

    //Ouvrir dans un autre onglet DPS
    const displayOnePDFDPS = async (urlFichierDocumentDPS) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/dps',
            {
                urlFichierDocumentDPS: urlFichierDocumentDPS,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            const file = new Blob([documentData.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;

        } catch (error) {
            console.error(error);
        }
    }

    const displayOnePictureDPS = async (urlFichierDocumentDPS) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/dps',
            {
                urlFichierDocumentDPS: urlFichierDocumentDPS,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            const fileURL = URL.createObjectURL(documentData.data);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;

        } catch (error) {
            console.error(error);
        }
    }

    const downloadDocumentDPS = async (urlFichierDocumentDPS, libelle, format) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/dps',
            {
                urlFichierDocumentDPS: urlFichierDocumentDPS,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            // create file link in browser's memory
            const href = URL.createObjectURL(documentData.data);
            
            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', libelle+'.'+format); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch (error) {
            console.error(error);
        }
    }

    //Ouvrir dans un autre onglet GROUPES
    const displayOnePDFGROUPES = async (urlFichierDocumentGroupe) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/groupes',
            {
                urlFichierDocumentGroupe: urlFichierDocumentGroupe,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            const file = new Blob([documentData.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;

        } catch (error) {
            console.error(error);
        }
    }

    const displayOnePictureGROUPES = async (urlFichierDocumentGroupe) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/groupes',
            {
                urlFichierDocumentGroupe: urlFichierDocumentGroupe,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            const fileURL = URL.createObjectURL(documentData.data);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;

        } catch (error) {
            console.error(error);
        }
    }

    const downloadDocumentGROUPES = async (urlFichierDocumentGroupe, libelle, format) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/groupes',
            {
                urlFichierDocumentGroupe: urlFichierDocumentGroupe,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            // create file link in browser's memory
            const href = URL.createObjectURL(documentData.data);
            
            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', libelle+'.'+format); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch (error) {
            console.error(error);
        }
    }

    //Ouvrir dans un autre onglet DEMANDES
    const displayOnePDFDEMANDES = async (urlFichierDocumentDemande) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/dpsDemandes',
            {
                urlFichierDocumentDemande: urlFichierDocumentDemande,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            const file = new Blob([documentData.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;

        } catch (error) {
            console.error(error);
        }
    }

    const displayOnePictureDEMANDES = async (urlFichierDocumentDemande) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/dpsDemandes',
            {
                urlFichierDocumentDemande: urlFichierDocumentDemande,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            const fileURL = URL.createObjectURL(documentData.data);
            const pdfWindow = window.open();
            pdfWindow.location.href = fileURL;

        } catch (error) {
            console.error(error);
        }
    }

    const downloadDocumentDEMANDES = async (urlFichierDocumentDemande, libelle, format) => {
        try {
            let documentData = await Axios.post('/authenticatedRoutes/getSecureFile/dpsDemandes',
            {
                urlFichierDocumentDemande: urlFichierDocumentDemande,
                idDPS: idDPS,
            },
            {
                responseType: 'blob'
            });
            
            // create file link in browser's memory
            const href = URL.createObjectURL(documentData.data);
            
            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', libelle+'.'+format); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } catch (error) {
            console.error(error);
        }
    }

    return (<>
        <MyAdvancedTable
            data={listeDocConcat}
            columns={colonnes}
            topButtonShow={false}
        />
    </>);
    
};

OneDPSDocuments.propTypes = {};

export default OneDPSDocuments;
